import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-left: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin-bottom: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { Icon } from '@scp/ui-shared/theme/icons';
import { ErrorText } from '@scp/ui-shared/components/typography';
import { baselineToRem } from '@scp/ui-shared/theme/utils';
var TextWrapper = styled.span(_templateObject(), function (props) {
  return props.marginBottomSize ? baselineToRem(props.marginBottomSize) : "".concat(props.bottomSpaceEm, "em");
});
var ErrorIcon = styled(Icon).attrs({
  size: baselineToRem(4),
  color: 'currentColor',
  name: 'warning'
})(_templateObject2(), baselineToRem(2));
var typographyMap = {
  error: ErrorText
};
var iconMap = {
  error: ErrorIcon
};
/**
 * A simple inline message (message and icon on opposite corners).
 *
 * @example ./__docs__/InlineMessage.md
 */

export function InlineMessage(_ref) {
  var type = _ref.type,
      children = _ref.children,
      _ref$bottomSpaceEm = _ref.bottomSpaceEm,
      bottomSpaceEm = _ref$bottomSpaceEm === void 0 ? 0 : _ref$bottomSpaceEm,
      marginBottomSize = _ref.marginBottomSize;
  var Icon = iconMap[type];
  return React.createElement(TextWrapper, {
    as: typographyMap[type],
    bottomSpaceEm: bottomSpaceEm,
    marginBottomSize: marginBottomSize
  }, children, React.createElement(Icon, null));
}